<template>
  <div id="popup-wrap">
    <van-popup v-model="isSwitchPublicShow" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-header">
          <div class="popup-title">切换公众号</div>
          <img src="../../../../../assets/img/h5/official/home_icon_cross.png" @click="handelCancel"/>
        </div>
        <div class="popup-content">
          <div class="public-list">
            <div class="public-item flex-between" v-for="(item,index) of bindPackage" :key="index">
              <div class="public-info">
                <div class="public-logo">
                  <img v-if="item.headImg" :src="item.headImg" alt="">
                  <img v-else src="../../../../../assets/img/official/weishouquan.png" alt="">
                </div>
                <div class="flex-column">
                  <div class="wechat-title" v-if="item.platformName == '' && item.platformUuid == ''">待授权公众号</div>
                  <div class="wechat-title" v-else>{{item.platformName}}</div>
                  <div class="package font-11">{{item.packageName}}</div>
                </div>
              </div>
              <div class="enter-sys-btn" @click="toHome(item)">进入系统</div>
            </div>
          </div>
        </div>
        <div class="btn-wrap">
          <div class="sure-btn" @click="toAuthorization">添加新公众号</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getUserUUID, getNickname, getPlatformUuid, getIsBasic, setPlatformUuid, setPlatformName, setIsBasic, setHasPackage, setIsAuthOfficial, getSnaphotId, setSnapshotId, setIsOver, setHeadImg } from '@/utils/auth'
import official from '@/javaApi/official'
const officialModel = new official()
export default {
  name: "SwitchPublic",
  data(){
    return{
      isSwitchPublicShow: false,
      listLoading: false,
      platformUuid: getPlatformUuid(),
      userUUID : getUserUUID(),
      bindPackage: [],
      authLink: process.env.VUE_APP_MOVIE_DOMAIN + 'movie/api/dis.distribution/toauth?openUserName=' + getNickname() + '&openUserUuid=' + getUserUUID() + '&snapshotId='+ getSnaphotId(),
    }
  },
  methods: {
    init: function () {
      this.isSwitchPublicShow = true
      this.loadPubilc()
    },
    loadPubilc:function(){
      this.listLoading = true
      officialModel.publicLogin({openUserUuid:this.userUUID}).then((response) => {
        let that = this
        var res = response.data
        if(res.code != 200){
          setPlatformUuid(0);
          setPlatformName('')
          setSnapshotId(0)
          setIsOver(1)
          setIsBasic(true)
          setHasPackage(false)
          setIsAuthOfficial(false)
          setHeadImg('')
          that.$Message.error(res.message)
          return
        }
        if(res.data.binds.length > 0){
          let tempSnapshotId = getSnaphotId()
          let defaultOfficial = res.data.binds[0];
          if(tempSnapshotId){
            let targetSnapshotId = tempSnapshotId
            if(targetSnapshotId == -1){
              // targetSnapShotId = -1 表示刚刚添加的公众号 买了套餐
              let lastOfficial = res.data.binds.length
              defaultOfficial =  res.data.binds[lastOfficial-1];
            }else{
              let i;
              let tempData;
              for(i=0;i<res.data.binds.length;i++){
                tempData = res.data.binds[i]
                if(targetSnapshotId != 0){
                  if(tempData['snapshotId'] == targetSnapshotId){
                    defaultOfficial = tempData
                    break;
                  }
                }else{
                  if(tempData['id']>0){
                    defaultOfficial = tempData
                    break;
                  }
                }
              }
            }
          }
          setPlatformUuid(defaultOfficial.platformUuid);
          setPlatformName(defaultOfficial.platformName)
          if(defaultOfficial.snapshotId !== null){
            setSnapshotId(defaultOfficial.snapshotId)
          }else{
            setSnapshotId(0)
          }
          setIsOver(defaultOfficial.isOver)
          setHeadImg(defaultOfficial.headImg)
          if(defaultOfficial.isProfit === 1){
            setIsBasic(false)
          }else{
            setIsBasic(true)
          }
          if(defaultOfficial.packageName !== null){
            setHasPackage(true)
          }else{
            setHasPackage(false)
          }
          if(defaultOfficial.platformUuid !== '' && defaultOfficial.platformName !== ''){
            setIsAuthOfficial(true)
          }else{
            setIsAuthOfficial(false)
          }
        }
        this.bindPackage = res.data.binds
        this.listLoading = false
      }).catch(error=>{
        this.listLoading = false
        if(error != 'token invalid'){
          this.$message.error('系统繁忙请稍后再试!')
        }
      })
    },
    //跳转到主页
    toHome(item){
      var platformUuid = item.platformUuid
      var snapshotId = item.snapshotId
      var platformName = item.platformName
      if(platformName == '' && platformUuid == ''){
        setIsAuthOfficial(false)
      } else {
        setIsAuthOfficial(true)
      }
      setSnapshotId(snapshotId)
      this.$store.dispatch('official/changeIsShowSlide', true)
      this.$store.dispatch('h_nav/changePromotionActiveIndex', '0')
      // 快照id
      this.$router.push({
        path: '/h5/official/statistics',
        query: { platformUuid: platformUuid,snapshotId:snapshotId }
      })
    },
    //添加新公众号
    toAuthorization(){
      setPlatformUuid(0);
      setPlatformName('')
      setSnapshotId(-1) //表示新添加的公众号
      setIsOver(1)
      setIsBasic(true)
      setHasPackage(false)
      setIsAuthOfficial(false)
      setHeadImg('')
      this.$store.dispatch('official/changeIsShowSlide', true)
      this.$store.dispatch('h_nav/changePromotionActiveIndex','7')
      this.$router.push({
        path: '/h5/official/dialog',
        query: { is_new: 1 }
      }).catch(err => { err })
    },
    handelCancel: function () {
      this.isSwitchPublicShow = false
    },
  }
}
</script>

<style lang="less" scoped>
.public-list{
  .flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .public-item{
    margin-bottom: 15px;
    .public-info{
      display: flex;
      .public-logo{
        margin-right: 8px;
        img{
          width: 40px;
        }
      }
      .flex-column{
        display: flex;
        flex-direction: column;
        .package{
          color: #3D9EFC;
        }
      }
    }
    .enter-sys-btn{
      background: #FFFFFF;
      border: 1px solid #FF8622;
      border-radius: 14px;
      width: 88px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      font-size: 12px;
      color: #FF8622;
    }
  }
  .public-item:last-child{
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/authorization/modal/SwitchPublic.vue